/**
 * @module:  初始化
 * @author: Liang Huang
 * @date: 2019-09-17 18:14:08
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { log } from '../utils/debug';
import { compareVersion } from '../utils/lang';
import globalError from '../inner/globalerror';
export default function initMixin(hybrid) {
  var hybridJS = hybrid;
  var showError = hybridJS.showError,
      JSBridge = hybridJS.JSBridge;
  var readyFunc;
  var isAllowReady = false;
  var isConfig = false;
  /**
   * 检查环境是否合法，包括
   * 检测是否有检测版本号，如果不是，给出错误提示
   * 是否版本号小于容器版本号，如果小于，给予升级提示
   */

  function checkEnvAndPrompt() {
    if (!hybridJS.runtime || !hybridJS.runtime.getYwkVersion) {
      showError(globalError.ERROR_TYPE_VERSION_NOT_SUPPORT);
    } else {
      hybridJS.runtime.getYwkVersion({
        success: function success(result) {
          var version = result.version;

          if (compareVersion(hybridJS.version, version) < 0) {
            showError(globalError.ERROR_TYPE_VERSION_NEED_UPGRADE);
          }
        },
        error: function error() {
          showError(globalError.ERROR_TYPE_INIT_VERSION_ERROR);
        }
      });
    }
  }
  /**
   * 页面初始化时必须要这个config函数
   * 必须先声明ready，然后再config
   * @param {Object} params
   * config的jsApiList主要是同来通知给原生进行注册的
   * 所以这个接口到时候需要向原生容器请求的
   */


  hybridJS.config = function (params) {
    if (isConfig) {
      showError(globalError.ERROR_TYPE_CONFIG_MODIFY);
    } else {
      isConfig = true;

      var success = function success() {
        if (readyFunc) {
          log('ready!');
          readyFunc();
        } else {
          isAllowReady = true; // 允许ready直接执行
        }
      };

      if (hybridJS.os.ywk) {
        checkEnvAndPrompt();
        hybridJS.auth.config(__assign({
          error: function error(_error) {
            var tips = JSON.stringify(_error);
            showError({
              error_code: globalError.ERROR_TYPE_CONFIG_ERROR.error_code,
              msg: tips
            });
          },
          success: success
        }, params));
      } else {
        success();
      }
    }
  };

  hybridJS.ready = function (callback) {
    if (!readyFunc) {
      readyFunc = callback;

      if (isAllowReady) {
        log('ready!');
        isAllowReady = false;
        readyFunc();
      }
    } else {
      showError(globalError.ERROR_TYPE_READY_MODIFY);
    }
  };
  /**
   * 注册接收原生的错误信息
   */


  JSBridge.registerHandler('handleError', function (data) {
    showError({
      error_code: globalError.ERROR_TYPE_NATIVE.error_code,
      msg: JSON.stringify(data)
    });
  });
}